// jquery and friends
require('jquery');
require('js/libs/jquery.nanoscroller.js');
require('js/theme.js');
require('js/libs/bootstrap.js');
require('js/libs/bootstrap-editable');
require('js/libs/bootstrap/popover');
require('datatables');
require('js/libs/jquery.dataTables.bootstrap');
require('js/libs/jquery.spin');
require('js/libs/jquery.magnific-popup');



// WEBPACK FOOTER //
// ./base.js